// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2e1Qq","footer":"Form_footer__2CySt"};